import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

// Paiements Membres › abonnements Stripe « en pause » reflétés sur les contrats (sync quotidienne + alerte propriétaire > 30 j)
export function PausedSubsPanel() {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/billing/pauses").then((r) => setD(r.data)).catch(() => setD({ rows: [] }));
  useEffect(() => { load(); }, []);
  const sync = async () => {
    setBusy(true);
    try { const { data } = await api.post("/billing/pauses/sync"); toast.success(`${data.paused} en pause · ${data.newly.length} nouvelle(s) · ${data.resumed.length} reprise(s)`); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Sync impossible"); }
    setBusy(false);
  };
  if (!d) return null;
  return (
    <div className="rounded-xl border border-sky-700/40 bg-sky-950/10 p-4 mb-4" data-testid="paused-subs-panel">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <div>
          <h3 className="font-bold text-sky-200">⏸ Abonnements en pause (Stripe) <span className="text-sky-500/70 font-normal">({d.rows.length})</span></h3>
          <p className="text-xs text-zinc-400 mt-0.5">Statut « en pause » lu chez Stripe et reflété sur le contrat (badge ⏸ dans Contrats élèves et Regrouper). Sync automatique chaque matin ; courriel au propriétaire quand une pause dépasse {d.alert_days} jours.{d.last_sync && <> Dernière sync : {d.last_sync.slice(0, 16).replace("T", " ")} UTC.</>}</p>
        </div>
        <button onClick={sync} disabled={busy} className="shrink-0 px-3 py-1.5 rounded-lg border border-sky-600 text-sky-200 hover:bg-sky-900/40 text-xs font-bold disabled:opacity-50" data-testid="paused-subs-sync">{busy ? "Stripe…" : "↻ Synchroniser maintenant"}</button>
      </div>
      {d.rows.length === 0 && <p className="text-xs text-emerald-300 mt-2" data-testid="paused-subs-empty">Aucun abonnement en pause ✔</p>}
      <ul className="mt-2 divide-y divide-zinc-800">
        {d.rows.map((c) => (
          <li key={c.id} className="py-2 flex items-center justify-between gap-2 text-sm" data-testid={`paused-sub-${c.id}`}>
            <div className="min-w-0"><b className="text-zinc-100">{c.full_name}</b> <span className="text-zinc-500">· {c.discipline || "—"} · {(c.tarif_mensuel || 0).toFixed(2)} $ · {c.email || c.parent_email || "—"}</span></div>
            <span className={`shrink-0 text-xs px-2 py-0.5 rounded ${c.over_30 ? "bg-rose-900/50 text-rose-200" : "bg-sky-900/50 text-sky-200"}`} data-testid={`paused-days-${c.id}`}>en pause depuis {c.paused_since || "?"}{c.days != null && ` · ${c.days} j`}{c.pause_resumes_at && ` · reprise ${c.pause_resumes_at}`}{c.over_30 && " · > 30 j"}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
